const DOMAIN_NAME = 'utilities';

export { DOMAIN_NAME };
